import * as e from "react";
var n = function(a) {
  return a();
}, t = e.useInsertionEffect ? e.useInsertionEffect : !1, c = t || n, f = t || e.useLayoutEffect;
export {
  c as useInsertionEffectAlwaysWithSyncFallback,
  f as useInsertionEffectWithLayoutFallback
};
